import PropTypes from 'prop-types'
import { useConfig } from '../../contexts/ConfigContext'
import ReturnHomeButton from './ReturnHomeButton'

/**
 * MinimalHeader Component
 *
 * Lightweight header for AI Dashboard and Narrative Dashboard
 * Shows app title/logo and a return home button
 * No navigation links - each dashboard is independent
 */
function MinimalHeader({ title, icon, showAppTitle = true }) {
  const { getAppTitle } = useConfig()

  return (
    <header className="bg-white shadow-sm border-b">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            {showAppTitle && (
              <div className="flex items-center gap-2">
                <img src="/img/logo.png" alt="App Logo" className="h-8 w-8" />
                <span className="text-xl font-bold text-gray-900 hidden sm:inline">
                  {getAppTitle()}
                </span>
              </div>
            )}

            {title && (
              <>
                <div className="hidden sm:block text-gray-300">|</div>
                <div className="flex items-center gap-2">
                  {icon && <span className="text-2xl">{icon}</span>}
                  <h1 className="text-xl sm:text-2xl font-bold text-gray-900">
                    {title}
                  </h1>
                </div>
              </>
            )}
          </div>

          <ReturnHomeButton variant="button" />
        </div>
      </div>
    </header>
  )
}

MinimalHeader.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.string,
  showAppTitle: PropTypes.bool,
}

export default MinimalHeader
